import { faTruck, faTruckContainer, faTruckPickup } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Delivery } from "../../models/Delivery";

type DeliveryVehicleType = "light" | "medium" | "heavy";

interface DeliveryVehicleTypeProps {
    delivery: Delivery;
    saveDelivery: (delivery: Delivery) => Promise<any>;
}

// This component displays the type of vehicle, which could be extended to show more details.
const DeliveryVehicleType: React.FC<DeliveryVehicleTypeProps> = (props) => {
    const [selectedVehicle, setSelectedVehicle] = React.useState<DeliveryVehicleType | null>(null);
    useEffect(() => {
        // Only update state if delivery.vehicleType is a valid VehicleType
        const validTypes: DeliveryVehicleType[] = ["light", "medium", "heavy"];
        if (validTypes.includes(props.delivery.vehicleType as DeliveryVehicleType)) {
            setSelectedVehicle(props.delivery.vehicleType as DeliveryVehicleType);
        }
    }, [props.delivery.vehicleType]);

    const updateVehicleType = (vehicleType: DeliveryVehicleType | null) => {
        const updatedDelivery = Object.create(props.delivery) as Delivery;
        updatedDelivery.vehicleType = vehicleType;
        props.saveDelivery(updatedDelivery);
    };

    const truckTypeIcon = (truckType: "light" | "medium" | "heavy") => {
        switch (truckType) {
            case "light":
                return faTruckPickup; // Placeholder for light truck icon
            case "medium":
                return faTruck; // Placeholder for medium truck icon
            case "heavy":
                return faTruckContainer; // Placeholder for heavy truck icon
            default:
                return faTruck; // Default icon
        }
    };
    return (
        <section className="mx-4 mt-4">
            <div className="bg-white rounded-2xl shadow-xl p-5 border border-gray-200/50">
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4 flex items-center gap-2">
                    <FontAwesomeIcon icon={faTruck} className="text-plot-orange" />
                    Vehicle Type
                </h3>
                <div className="grid grid-cols-3 gap-3 md:gap-6">
                    {(["light", "medium", "heavy"] as const).map((type) => (
                        <button
                            key={type}
                            type="button"
                            onClick={() => updateVehicleType(type)}
                            className={`flex flex-col items-center cursor-pointer p-5 rounded-xl transition-all duration-200 ${
                                selectedVehicle === type
                                    ? "bg-linear-to-br from-plot-orange to-plot-orange/80 shadow-lg scale-105 border-2 border-plot-orange text-white hover:text-plot-orange"
                                    : "bg-linear-to-br from-gray-50 to-gray-100 border-2 border-gray-200 hover:border-gray-300 hover:shadow-md text-gray-400 hover:text-plot-orange"
                            }`}
                        >
                            <FontAwesomeIcon size="2x" className="mb-2" icon={truckTypeIcon(type)} />
                            <p className="text-xs font-bold uppercase tracking-wide">{type}</p>
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DeliveryVehicleType;
